export class SimulationData {
    singleAmount: number;
    monthlyAmount: number;
    duration: number;
}
